import React, { useEffect, useState } from 'react';
import { FaDoorOpen, FaUserTie, FaBox, FaPen, FaArrowAltCircleDown, FaFilter, FaYoutube, FaCalendarCheck, FaRegChartBar } from 'react-icons/fa';
import { useNavigate, Link } from 'react-router-dom';
import { useUser } from '../UserContext';
import './index.css';
import logo from '../../imagens/TSTRIPAS.png';

const Menu = () => {
  const navigate = useNavigate();
  const { userInfo } = useUser();

  // Mensagens
  const [mensagens, setMensagens] = useState([]);
  const [showModalMsg, setShowModalMsg] = useState(false);
  const [temMsgNaoLida, setTemMsgNaoLida] = useState(false);
  const [filtroLidas, setFiltroLidas] = useState('naoLidas');
  
  useEffect(() => {
    if (!userInfo.username || !userInfo.company) {
      navigate('/home');
    }
  }, [userInfo, navigate]);

  const credentials = btoa(`${userInfo.alias};${userInfo.venLogin}:${userInfo.venSenha}`);

  useEffect(() => {
    async function fetchMensagens() {
      try {
        const res = await fetch(`${userInfo.url}/mensagem/${userInfo.ven_id}`, {
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          }
        });
        const msgs = await res.json();
        setMensagens(msgs);
        setTemMsgNaoLida(msgs.some(m => m.msgLida === 'F'));
        if (msgs.some(m => m.msgLida === 'F')) { setShowModalMsg(true); }
      } catch {}
    }
    fetchMensagens();
  }, [userInfo, credentials]);

  // Ordena e filtra as mensagens conforme o filtro
  const mensagensFiltradas = [...mensagens]
    .sort((a, b) => new Date(b.msgDtaRegistro) - new Date(a.msgDtaRegistro))
    .filter(msg => filtroLidas === 'naoLidas' ? msg.msgLida === 'F' : msg.msgLida === 'T');

  useEffect(() => {
    if (showModalMsg) {
      setFiltroLidas('naoLidas'); // Sempre abre mostrando não lidas
    }
  }, [showModalMsg]);

  const handleNavigation = (path) => {
    navigate(path);
  };

async function marcarComoLida(msgId) {
  try {
    const res = await fetch(`${userInfo.url}/mensagem/leitura/${msgId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'empresa': userInfo.alias,
        'Authorization': `Basic ${credentials}`,
      },
      body: JSON.stringify({ msgId, venId: userInfo.ven_id })
    });
    if (!res.ok) {
      const errorText = await res.text();
      console.error('Erro ao marcar como lida:', res.status, errorText);
      alert('Erro ao marcar mensagem como lida!');
      return;
    }
    // Atualiza lista
    const resMsgs = await fetch(`${userInfo.url}/mensagem/${userInfo.ven_id}`, {
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          }
        });
    const msgs = await resMsgs.json();
    setMensagens(msgs);
    setTemMsgNaoLida(msgs.some(m => m.msgLida === 'F'));
  } catch (err) {
    console.error('Falha na requisição:', err);
    alert('Falha na conexão com o servidor!');
  }
}

 /* async function marcarTodasComoLidas() {
    const ids = mensagens.filter(m => m.msgLida === 'F').map(m => m.msgId);
    await fetch(`${userInfo.url}/mensagem`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json',
        'empresa': userInfo.alias,
        'Authorization': `Basic ${credentials}`,
       },
      body: JSON.stringify({ msgIds: ids, venId: userInfo.ven_id })
    });
    // Atualiza lista
    const res = await fetch(`${userInfo.url}/mensagem`);
    const msgs = await res.json();
    setMensagens(msgs);
    setTemMsgNaoLida(false);
  }*/

  return (
    <>
    <div className="menu-container">
      <header className="header">
        <img src={logo} alt="Logo" className="header-logo" />
        <h2>Bem-vindo, {userInfo.username}!</h2>
        <h3>Empresa: {userInfo.company}</h3>
        <h1>Por favor clique sobre a operação desejada. <FaArrowAltCircleDown size={35} /></h1>
      </header>
      <div className={userInfo.mensagem === 'T' ? 'link-sair' : 'link-sair-no-msg'}>
        {userInfo.mensagem === 'T' && (
        <button
          className={temMsgNaoLida ? 'btn-mensagem destaque' : 'btn-mensagem'}
          onClick={() => setShowModalMsg(true)}
        >
          📩
        </button>)}
        <Link to="/" className="link-style-sair">
          <FaDoorOpen style={{ marginRight: '5px' }} /> Sair
        </Link>
      </div>

      <div className="buttons-container">
        <button onClick={() => handleNavigation('/cliente')} className="menu-button">
          <FaUserTie size={150} />
          <span>CLIENTES</span>
        </button>
        <button onClick={() => handleNavigation('/produto')} className="menu-button">
          <FaBox size={150} />
          <span>TABELA DE PREÇOS</span>
        </button>
        <button onClick={() => handleNavigation('/venda')} className="menu-button">
          <FaPen size={150} />
          <span>PEDIDOS</span>
        </button>
        <button onClick={() => handleNavigation('/relatorio')} className="menu-button">
          <FaFilter size={150} />
          <span>RELATÓRIOS</span>
        </button>
        {userInfo.agenda === 'T' && (
          <button onClick={() => handleNavigation('/Agenda')} className="menu-button">
            <FaCalendarCheck size={150} />
            <span>AGENDA</span>
          </button>
        )}
        {userInfo.gerencial === 'T' && (
          <button onClick={() => handleNavigation('/gerencial')} className="menu-button">
            <FaRegChartBar size={150} />
            <span>GERENCIAL</span>
          </button>
        )}
      </div>
    </div>
    <div id='video' className='video'>
    <a href="https://www.youtube.com/watch?v=0TGh99CGyXo&list=PLUEOvUIrTNs9n9xtANkFdw5eBopYjiafx&pp=gAQB" target="_blank" rel="noopener noreferrer" className="menu-button">
      <FaYoutube size={100} />
      <span>You Tube</span>
    </a>  
    </div>
    {showModalMsg && userInfo.mensagem === 'T' && (
      <div className="modal-msg">
        <div className="modal-content-msg">
          <h2>Mensagens</h2>
          <div className='btn-group'>
            <button className='btn-fechar-msg' onClick={() => setShowModalMsg(false)}>Fechar</button>
          </div>
          <div className='select-msg'>
            <input 
              type="checkbox" 
              id="select-nao-lidas" 
              checked={filtroLidas === 'naoLidas'}
              onChange={() => setFiltroLidas('naoLidas')} />
            <label htmlFor="select-nao-lidas">Não Lidas</label>
            <input 
              type="checkbox" 
              id="select-lidas" 
              checked={filtroLidas === 'lidas'}
              onChange={() => setFiltroLidas('lidas')} />
            <label htmlFor="select-lidas">Lidas</label>
          </div>
          {mensagensFiltradas.length === 0 ? <p>Sem mensagens</p> : (
            <>
              <ul>
                {mensagensFiltradas.map(msg => (
                  <li key={msg.msgId} style={{ background: msg.msgLida === 'F' ? '#ffeaea' : '#f4f6f8', marginBottom: 8, padding: 8, borderRadius: 8 }}>
                    <strong>{msg.msgDescricao}</strong>
                    <br />
                    <div className='msg-data'>
                      <small>{new Date(msg.msgDtaRegistro).toLocaleString()}</small>
                      {msg.msgLida === 'F' && (
                        <button style={{ marginLeft: 8 }} onClick={() => marcarComoLida(msg.msgId)}>Marcar como lida</button>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
              <div className='btn-group'>
                <button className='btn-fechar-msg' onClick={() => setShowModalMsg(false)}>Fechar</button>
              </div>
            </>
          )}
        </div>
      </div>
    )}
    </>
  );
};

export default Menu;